module.exports = __webpack_public_path__ + "static/media/washington-dc-45.940effc1.jpg";